import angular from 'angular';
import _ from 'lodash';
import {vrmConfig} from '@/config';

export const vrmConfigModule = angular.module('vrm.config', [])
    .constant('vrmConfig', _.clone(vrmConfig));
